import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';

import styles from './PdpStatusBadge.module.css';

type BadgeTone = 'contract' | 'new' | 'neutral';

export const PdpStatusBadge = ({ label, tone }: { label: string; tone: BadgeTone }) => (
  <Text
    as="span"
    className={cn(
      'inline-flex h-7 shrink-0 items-center whitespace-nowrap rounded-[14px] border border-transparent pl-[9px] text-[12px] font-medium leading-3 tracking-[-0.36px]',
      styles[tone],
    )}
  >
    {label}
  </Text>
);
